import { useEffect } from "react";
import { Link } from "react-router-dom";
import Seo from "../../Seo";
import { SITE_ORIGIN } from "../../../config/site";
import L from "../../../constants/baysportLabels";
import { TRIAL_DAYS } from "../../../constants/trial";
import { trackTryClick } from "../../../analytics/metrikaGoals";
import { yandexMetrikaParams } from "../../../analytics/yandexMetrika";
import MarketingShell from "../MarketingShell";
import { MARKETING_PATHS } from "../marketingNav";
import s from "../marketing.module.css";

const PATH = MARKETING_PATHS.about;

export default function AboutPage() {
  useEffect(() => {
    yandexMetrikaParams({ landing: "about" });
  }, []);

  const onTry = () => trackTryClick({ landing: "about" });

  return (
    <MarketingShell metrikaLanding="about">
      <Seo
        title={`О компании ${L.productName}`}
        description={`${L.productName} — CRM для спортивных клубов и тренеров. Журнал, абонементы и кабинет родителей под брендом секции. Self-serve запуск за вечер.`}
        canonicalUrl={`${SITE_ORIGIN}${PATH}`}
        keywords={[L.productName, "о компании", "crm спортивный клуб"]}
      />

      <section className={s.pageHero}>
        <div className={s.pageHeroInner}>
          <p className={s.eyebrow}>О компании</p>
          <h1>Делаем учёт секции проще Excel и чатов</h1>
          <p>
            {L.productName} — продукт для владельцев спортивных школ и тренеров:
            журнал на телефоне, абонементы, оплаты и кабинет родителей без
            заказной разработки.
          </p>
        </div>
      </section>

      <section className={s.section}>
        <h2 className={s.sectionTitle}>Зачем мы это делаем</h2>
        <div className={s.prose}>
          <p>
            Секции живут в тетрадях, WhatsApp и таблицах. Это работает, пока
            учеников мало. Дальше появляются должники, замены, вопросы родителей
            и вечерняя «сверка».
          </p>
          <p>
            Мы собираем контур <strong>занятие → отметка → абонемент → родитель</strong>{" "}
            в одном кабинете. Без внедрения на месяцы и без цены «как у сетей ФОК».
          </p>
          <p>
            Запуск — self-serve: зарегистрировали клуб, добавили группу, отметили
            тренировку. {TRIAL_DAYS} дней полного доступа, карта не нужна.
          </p>
        </div>

        <div className={s.stats}>
          <div className={s.stat}>
            <strong>{TRIAL_DAYS} дней</strong>
            <span>триал без карты</span>
          </div>
          <div className={s.stat}>
            <strong>Self-serve</strong>
            <span>запуск без менеджера внедрения</span>
          </div>
          <div className={s.stat}>
            <strong>PWA</strong>
            <span>приложение клуба без магазина</span>
          </div>
        </div>
      </section>

      <section className={s.section}>
        <h2 className={s.sectionTitle}>Что можно почитать</h2>
        <p className={s.sectionLead}>
          Разборы и инструкции — в блоге. Ниши и продукт — на отдельных страницах.
        </p>
        <div className={s.cardGrid}>
          <Link to={MARKETING_PATHS.blog} className={s.card}>
            <h3>Блог</h3>
            <p>Статьи про журнал, абонементы и запуск секции</p>
          </Link>
          <Link to={MARKETING_PATHS.forWhom} className={s.card}>
            <h3>Для кого</h3>
            <p>Ниши: единоборства, танцы, плавание и другие</p>
          </Link>
          <Link to={MARKETING_PATHS.features} className={s.card}>
            <h3>Возможности</h3>
            <p>Модули платформы одним списком</p>
          </Link>
        </div>
      </section>

      <section className={s.ctaBand}>
        <h2>Попробуйте на своей группе</h2>
        <p>{TRIAL_DAYS} дней бесплатно. Потом — тариф под размер секции.</p>
        <div className={s.heroActions} style={{ justifyContent: "center" }}>
          <Link
            to={MARKETING_PATHS.buy}
            className={`${s.btn} ${s.btnPrimary} ${s.btnLg}`}
            onClick={onTry}
          >
            Создать клуб
          </Link>
          <Link to={MARKETING_PATHS.pricing} className={`${s.btn} ${s.btnOutline} ${s.btnLg}`}>
            Тарифы
          </Link>
        </div>
      </section>
    </MarketingShell>
  );
}
